<app-view-title [showBack]="false"  mode="primary"></app-view-title>

<div  style="display: flex; flex-direction: column; height: 100%;">
  <div style="text-align:center;">
    <img class="logo" src="/Styles/OneWay/Logo.png" style="max-width:250px; margin:40px" />
    <br />
    <p style="margin-bottom:75px">{{'Intellitrailer.SelectFamily.txtWelcomeMessage.' + appSettings.settings.theme | translate: 'Welcome to ' + appSettings.settings.theme + '!'}}</p>
  </div>
 
  <div style="flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 10; background-size: cover; background-position: center; border-radius: 25px 25px 0px 0px; background-image: url(https://www.onewayrental.com/storage/3C95EDD1D3F56AB97D9F7A11BD4990D3E8B6B2C1B13A98954187246FE6E1C883/c483312170494f5584ed39cdd7166dcf/640-427-0-jpeg.Jpeg/media/4b31dda743bd43dc983813e059327cab/AS_G_LS_AdobeStock_266306881.jpeg) ">
    <button type="button" mat-raised-button (click)="start()" style="background: white !important; width: 250px; margin-bottom: 30px; color: var(--action-secondary-background) !important; ">Rent a trailer</button>
    <button type="button" mat-raised-button (click)="mybooking()" style="background: white !important; width: 250px; color: var(--action-secondary-background) !important;">My reservations</button>
  </div>

</div>
<div class="bottom-nav" style="z-index: 15;">
  <div class="bottom-nav-home" *ngIf="typeSettings.isShowMenu">
    <div (click)="toggleNewUserInfo(false)" class="link">{{'Intellitrailer_Home_Home_HowDoesItWork' | translate: 'How does it work?' }}</div>
  </div>
  <div class="bottom-nav-select-location" *ngIf="!typeSettings.isShowMenu">
    <div class="select-location">{{'Intellitrailer_Home_Home_cmdChooseALocation' | translate: 'Choose a location'}}</div>
  </div>
</div>

